import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { authActions, getEmail, getAuthenticated } from '../../core/auth';
import Header from '../components/header';
import Footer from '../components/footer';
import EnvModeSnackBar from '../components/envModeSnackBar';

class App extends Component {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  static propTypes = {
    email: PropTypes.string.isRequired,
    authenticated: PropTypes.bool.isRequired,
    children: PropTypes.array.isRequired,
    signOut: PropTypes.func.isRequired,
  };

  render() {
    const { authenticated, email, signOut } = this.props;
    return (
      <div>
        <Header authenticated={authenticated} signOut={signOut} email={email} />

        <main className="main">{this.props.children}</main>

        <EnvModeSnackBar />

        <Footer
          copyright="Copyright 2017 Nazotoki Bingo. All Rights Reserved."
          description="powered by nazoneko"
        />
      </div>
    );
  }
}

//= ====================================
//  CONNECT
//-------------------------------------

const mapStateToProps = createStructuredSelector({
  email: getEmail,
  authenticated: getAuthenticated,
});

export default connect(mapStateToProps, authActions)(App);



// WEBPACK FOOTER //
// ./src/views/app/index.js